export const PersonalizedVariable = {
    path: '/personalized_variables',
    name: 'personalized_variables',
    component: () => import('@/views/Edms/PersonalizedVariable/PersonalizedVariablePage.vue'),
    children: [
        {
            path: '/personalized_variables/add',
            name: 'personalized_variables.add',
            component: () => import('@/views/Edms/PersonalizedVariable/Form/PersonalizedVariableForm.vue'),
            props: { addAction: true }
        },
        {
            path: '/personalized_variables/edit/:id',
            name: 'personalized_variables.edit',
            component: () => import('@/views/Edms/PersonalizedVariable/Form/PersonalizedVariableForm.vue'),
            props: { updateAction: true }
        },
        {
            path: '/personalized_variables/delete/:id',
            name: 'personalized_variables.delete',
            component: () => import('@/views/Edms/PersonalizedVariable/Form/PersonalizedVariableForm.vue'),
            props: { deleteAction: true }
        },
        {
            path: '/personalized_variables/view/:id',
            name: 'personalized_variables.view',
            component: () => import('@/views/Edms/PersonalizedVariable/Form/PersonalizedVariableForm.vue'),
            props: { viewAction: true }
        },
    ],
}
